/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BraintreeService, ModalService } from 'app/shared/services';

@Component({
  selector: '[orderModalGeneral]',
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderModalComponent implements OnInit {
  @Input() receipt;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  purchaseLogo = '/assets/images/rebrand/nextpro-logo.png';
  loading = true;

  constructor(
    private braintreeService: BraintreeService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.setBillingData();
  }

  close() {
    this.modalService.hideModal();
    this.closeModal.emit({});
  }

  private setBillingData() {
    if (!this.receipt) {
      return;
    }

    this.receipt.couponTotal = parseFloat(this.receipt.initialPrice) - parseFloat(this.receipt.total);
    this.braintreeService.findTransaction(this.receipt.braintreeTransactionId).subscribe((transaction) => {
      const card = transaction.creditCard;
      if (card) {
        this.receipt.cardholderName = card.cardholderName;
        this.receipt.cardExpirationDate = card.expirationDate;
        this.receipt.cardImage = card.imageUrl;
        this.receipt.cardNumberLast4Digits = card.last4;
        this.receipt.paymentMethod = card.cardType;
      }
      this.loading = false;
      this.cdr.detectChanges();
    });
  }
}
